<template>
  <div id="menu-list">
    <el-menu
      :router="true"
      :default-active="$route.path">
      <el-menu-item index="/books/new">
        <i class="el-icon-document"></i>
        <span>本をつくる</span>
      </el-menu-item>
      <el-menu-item index="/books">
        <i class="el-icon-menu"></i>
        <span>本の管理</span>
      </el-menu-item>
      <el-submenu v-if="isEdit" :index="'/books/' + $route.params.id">
        <template slot="title">
          <i class="el-icon-edit"></i>
          <span>本の編集</span>
        </template>
        <el-menu-item :index="'/books/' + $route.params.id + '/cover'">基本設定</el-menu-item>
        <el-menu-item :index="'/books/' + $route.params.id + '/chapters'">章の編集</el-menu-item>
        <el-menu-item :index="'/books/' + $route.params.id + '/bodies'">本文編集</el-menu-item>
        <el-menu-item index="" @click="FileUtil.downloadPdf($route.params.id, true)">プレビュー</el-menu-item>
        <el-menu-item index="" @click="FileUtil.downloadPdf($route.params.id)">PDF出力</el-menu-item>
        <el-menu-item index="" @click="FileUtil.downloadEpub($route.params.id)">ePub出力</el-menu-item>
      </el-submenu>
      <el-menu-item index="/account">
        <i class="el-icon-setting"></i>
        <span>アカウント情報</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'menu-list',
  created () {
    console.log('created:menu-list')
  },
  methods: {
    resize () {
      if (document.getElementById('menu-list')) {
        document.getElementById('menu-list').style.height = this.contentHeight() + 'px'
      }
    }
  },
  computed: {
    isEdit () {
      return this.$route.path.indexOf('/books/' + this.$route.params.id) > -1
    }
  },
  mounted () {
    this.resize()

    this.timer = 0

    var self = this
    window.addEventListener('resize', function (e) {
      e.preventDefault()

      if (self.timer > 0) {
        clearTimeout(self.timer)
      }

      self.timer = setTimeout(function () {
        self.resize()
      }, 100)
    })
  },
  updated () {
    console.log('updated:menu-list')
    console.log('bookId:' + this.bookId)
    this.resize()
  }
}
</script>

<style scoped>
#menu-list{
  border-top:solid 1px #e6e6e6;
}
.el-menu{
  border-right:none;
}
</style>



// WEBPACK FOOTER //
// src/components/02-organisms/MenuList.vue